import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordCheckEmailPath = () => urlHelper('/forgot-password/check-email');
